import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    updateNiptDob,
    createNiptDob,
    getUpdatedCustomerReportData,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const JakReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])


    //Booking Data
    const [smnMlpaReport, setjakReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setjakReport(data);
    }, [reportListParameter])

    useEffect(() => {
        setSample_Collected(smnMlpaReport[0]?.collection_date);
        setSample_Receivedtime(smnMlpaReport[0]?.pickup_time);
        setdesignation(smnMlpaReport[0]?.designation);
        setGender(smnMlpaReport[0]?.customer_gender);
        setSample_Received(smnMlpaReport[0]?.pickup_date);
        setName(smnMlpaReport[0]?.customer_name);
        setAge(smnMlpaReport[0]?.customer_age);
        setDob(smnMlpaReport[0]?.dob);
    }, [smnMlpaReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);
        }
        else {

            setAge(smnMlpaReport[0]?.customer_age);
        }
    }, [dob]);


    //Clinical indication
    const [smnMlpaClinData, setjakClinData] = useState<any>([]);
    useEffect(() => {
        const bcrclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                bcrclincdata?.push({ ...list });
            });
        }
        setjakClinData(bcrclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...smnMlpaClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setjakClinData(storeData);
    }


    //Clinical History
    const [smnMlpahistory, setsmnMlpahistory] = useState<any>([]);
    useEffect(() => {
        const bcrclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_significance &&
            reportListParameter?.clinical_significance?.length > 0
        ) {
            reportListParameter?.clinical_significance?.map((list: any) => {
                bcrclincdata?.push({ ...list });
            });
        }
        setsmnMlpahistory(bcrclincdata);
    }, [reportListParameter]);

    const updateHistory = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...smnMlpahistory]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setsmnMlpahistory(storeData);
    }



    // result
    let Data = [
        {
            id: 1,
            srno: "1",
            gene: " SMN1",
            location: "Exon7",
            nameDeletion_Duplication: "NA",
            FinalRatio: "NA"
        },
        {
            id: 2,
            srno: "2",
            gene: " SMN1",
            location: "Exon8",
            nameDeletion_Duplication: "NA",
            FinalRatio: "NA"
        },
        {
            id: 3,
            srno: "3",
            gene: " SMN2",
            location: "Exon7",
            nameDeletion_Duplication: "NA",
            FinalRatio: "NA"
        },
        {
            id: 4,
            srno: "4",
            gene: " SMN2",
            location: "Exon8",
            nameDeletion_Duplication: "NA",
            FinalRatio: "NA"
        },
    ];
    const [smnMlla, setsmnMlpaResult] = useState([]);
    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setsmnMlpaResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            data = reportListParameter?.result_brca[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "srno":
                newItem.srno = value;
                break;
            case "gene":
                newItem.gene = value;
                break;
            case "location":
                newItem.location = value;
                break;
            case "nameDeletion_Duplication":
                newItem.nameDeletion_Duplication = value;
                break;
            case "FinalRatio":
                newItem.FinalRatio = value;
                break;


        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    // Result Remark
    const [resultremark, setresultremark] = useState<any>([]);
    useEffect(() => {
        const bcrclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks2 &&
            reportListParameter?.remarks2?.length > 0
        ) {
            reportListParameter?.remarks2?.map((list: any) => {
                bcrclincdata?.push({ ...list });
            });
        }
        setresultremark(bcrclincdata);
    }, [reportListParameter]);

    const updateRemark = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...resultremark]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setresultremark(storeData);
    }


    //Methodology
    const [smnMethodology, setsmnMlpaMethodology] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology &&
            reportListParameter?.methodology.length > 0
        ) {
            reportListParameter?.methodology?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsmnMlpaMethodology(data);
    }, [reportListParameter]);

    const updateMethology = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...smnMethodology]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsmnMlpaMethodology(storeData);
    }





    //Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }


    //INTERPRETATION
    const [INTERPRETATION, setINTERPRETATION] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.interpretation
            &&
            reportListParameter?.interpretation
                .length > 0
        ) {
            reportListParameter?.interpretation
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setINTERPRETATION(data);
    }, [reportListParameter]);

    const updateInterpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...INTERPRETATION]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setINTERPRETATION(storeData);
    }


    //   GraphRemark
    const [GraphRemark, setGraphRemark] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks1

            &&
            reportListParameter?.remarks1

                .length > 0
        ) {
            reportListParameter?.remarks1

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setGraphRemark(data);
    }, [reportListParameter]);

    const updateGraphRemark = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...GraphRemark]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraphRemark(storeData);
    }



    //upload image 
    const [filePreviews, setFilePreviews] = useState<Array<string[]>>([]);

    const handleFileUpload = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };



    //graph 0
    const [smnMlpaGraph, setjakGraph] = useState<any>([]);
    useEffect(() => {
        const Jakgraph: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image
            &&
            reportListParameter?.graph_image
                ?.length > 0
        ) {
            reportListParameter?.graph_image
                ?.map((list: any) => {
                    Jakgraph?.push({ ...list });
                });
        }
        setjakGraph(Jakgraph);
    }, [reportListParameter]);

    const updateGraphData = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...smnMlpaGraph]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakGraph(storeData);
    }


    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }


    //doctor list
    const [smnMlpadoctorlist, setjakdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setjakdoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...smnMlpadoctorlist]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakdoctorList(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }


    //Submit Data

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (smnMlpaReport.length > 0) {
            smnMlpaReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (smnMlpaClinData.length > 0) {
            smnMlpaClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (smnMethodology.length > 0) {
            smnMethodology?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (smnMlpaGraph.length > 0) {
            smnMlpaGraph?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (smnMlpadoctorlist.length > 0) {
            smnMlpadoctorlist?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (resultremark.length > 0) {
            resultremark?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (smnMlpahistory.length > 0) {
            smnMlpahistory?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (INTERPRETATION.length > 0) {
            INTERPRETATION?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (GraphRemark.length > 0) {
            GraphRemark?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        const stringify = JSON.stringify(tableData);
        if (smnMlla.length > 0) {
            smnMlla?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        }
        else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };

    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
     const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${smnMlpaReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>

                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="main-contain-section"> */}
                    <div className="main-content3">.</div>
                    <div
                        style={{
                            fontSize: "35px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#400354" }}>SMN -</span> <span style={{ fontWeight: "bold", color: "#750b1e" }}>MLPA</span>
                    </div>

                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "25px", marginTop: "10px" }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {smnMlpaReport[0]?.pk
                                                ? smnMlpaReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <>
                                            <Grid item xs={3.5}>
                                                Age
                                            </Grid>
                                            {dob === "" || dob === null ? (
                                                <Grid item xs={8.5}>
                                                    :  <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                </Grid>
                                            )
                                                : (
                                                    <Grid item xs={8.5} style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}>
                                                        : {age} Y
                                                    </Grid>
                                                )}
                                        </>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {smnMlpaReport[0]?.center?.name && smnMlpaReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="tissue"> FFPE TISSUE BLOCK</option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "96%", marginLeft: "25px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{smnMlpaReport[0]?.packages[0]?.name}</h6>
                    </div>
                    <div className="br">.</div>
                    {/* clinical History */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL HISTORY </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {smnMlpahistory?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px", fontSize: "18px" }}
                                            rows={4}
                                            cols={114}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateHistory(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>

                    {/* clinical indication  */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL INDICATION </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {smnMlpaClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px", fontSize: "18px" }}
                                            rows={4}
                                            cols={114}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    <br />
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>RESULT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {resultremark?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px", fontSize: "18px" }}
                                            rows={4}
                                            cols={114}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateRemark(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>

                    <div style={{
                        width: "93%",
                        display: "flex",
                        fontSize: "18px",
                        height: "45px",
                        border: "1px solid rgb(38, 31, 87)",
                        marginLeft: "40px",
                        textAlign: "center",
                        fontWeight: "bold",
                    }}>
                        <div style={{ width: "10%", borderRight: "1px solid rgb(38, 31, 87)", height: "45px", }}>  <p style={{ padding: "10px" }}>Sr.No.</p></div>
                        <div style={{ width: "15%", borderRight: "1px solid rgb(38, 31, 87)", }}><p style={{ padding: "10px" }}>Gene</p></div>
                        <div style={{ width: "25%", borderRight: "1px solid rgb(38, 31, 87)", }}><p style={{ padding: "10px" }}>Location</p></div>
                        <div style={{ width: "40%", borderRight: "1px solid rgb(38, 31, 87)", }}><p style={{ padding: "10px" }}>Deletion/Duplication</p></div>
                        <div style={{ width: "20%" }}><p style={{ padding: "10px" }}>Final Ratio (FR)</p></div>

                    </div>
                    <div style={{ width: "100%" }}>
                        <div className="contain" style={{ border: "1px solid rgb(38, 31, 87)", width: "93%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    fontSize: "14px",
                                                    height: "45px",
                                                }}

                                            >
                                                <div style={{ width: "10%", borderBottom: "1px solid rgb(38, 31, 87)", borderRight: "1px solid rgb(38, 31, 87)", }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "5px", fontSize: "18px", textAlign: "center", marginTop: "9px" }}
                                                            value={list?.srno}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "srno", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div style={{ width: "15%", borderBottom: "1px solid rgb(38, 31, 87)", borderRight: "1px solid rgb(38, 31, 87)", }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "5px", marginTop: "9px", fontSize: "18px", textAlign: "center" }}
                                                            value={list?.gene}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "gene", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div style={{ width: "25%", borderBottom: "1px solid rgb(38, 31, 87)", borderRight: "1px solid rgb(38, 31, 87)", }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "10px", marginTop: "9px", fontSize: "18px", textAlign: "center" }}
                                                            value={list?.location}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "location", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div style={{ width: "40%", borderBottom: "1px solid rgb(38, 31, 87)", borderRight: "1px solid rgb(38, 31, 87)", }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "9px", fontSize: "18px", textAlign: "center" }}
                                                            value={list?.nameDeletion_Duplication}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "nameDeletion_Duplication", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                                <div
                                                    style={{ width: "20%", borderBottom: "1px solid rgb(38, 31, 87)" }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "96%", background: "none", marginTop: "9px", fontSize: "18px", textAlign: "center", marginLeft: "3px" }}
                                                            value={list?.FinalRatio}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "FinalRatio", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                            </div>

                                        </>
                                    );
                                })}

                        </div>
                    </div>
                    <br />
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "10px" }}>
                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="main-content2">.</div>
                    <div className="pmain-content5">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "600px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{smnMlpaReport[0]?.designation}&nbsp;{smnMlpaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{smnMlpaReport[0]?.pk}
                    </div>
                    <br />
                    <div className="SangerSequencing-br">.</div>
                    <div className="SangerSequencing-clinical__indicatio" >
                        <span
                            className="SangerSequencing-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            INTERPRETATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {INTERPRETATION.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={5}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateInterpretation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            RECOMMENDATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "50px", fontSize: "18px", fontWeight: "bold" }}>
                        <p>
                            Please correlate clinically and genetic counselling is recommended.
                        </p>
                    </div>
                    <div className="br">.</div>
                    <div>
                        {GraphRemark.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "18px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", textAlign: "center", fontWeight: "bold" }}
                                            rows={2}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateGraphRemark(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div>
                        <>
                            {smnMlpaGraph.map((list: any, index: number) => {

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '95%',
                                            padding: 15,
                                            textAlign: 'left',
                                            fontSize: '14px',
                                            marginLeft: '135px',
                                        }}
                                    >
                                        {/* Display base64-encoded image */}
                                        {thirdP === 'edit' &&
                                            list.parameter_type === 'free_text' &&
                                            list.parameter_name === 'graph_image13' &&
                                            list.parameter_value &&
                                            list.parameter_value.startsWith('data:image/') && (
                                                <div>
                                                    <img
                                                        src={list.parameter_value}
                                                        alt={`Image ${index}`}
                                                        style={{ width: '80%', height: 'auto', maxHeight: '350px' }}
                                                    />
                                                </div>
                                            )}
                                        {/* Display file previews */}
                                        {index === 0 &&
                                            filePreviews[index] &&
                                            filePreviews[index].map((preview: string, previewIndex: number) => (
                                                <img
                                                    key={previewIndex}
                                                    src={preview}
                                                    alt={`File Preview ${previewIndex + 1}`}
                                                    style={{ width: '80%', height: 'auto', maxHeight: '350px' }}
                                                />
                                            ))}
                                        {thirdP !== 'edit' && (
                                            <input
                                                type="file"
                                                onChange={(e) => handleFileUpload(e.target.files, index, list)}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </>
                    </div>
                    <div style={{ width: "93%", padding: 15, textAlign: "left", fontSize: "18px", marginLeft: "35px" }}>
                        <p>
                            <b>Comment:</b>The result must be interpreted in the context of the individual’s clinical and biochemical profile.
                        </p>
                    </div>


                    <div className="br1">.</div>

                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "40px" }}>
                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>

                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    {/* static data  */}
                    <div className="main-content2">.</div>
                    <div className="pmain-content5">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{smnMlpaReport[0]?.designation}&nbsp;{smnMlpaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{smnMlpaReport[0]?.pk}
                    </div>
                    <br />
                    <div style={{
                        width: "70%",
                        fontSize: "18px",
                        border: "1px solid rgb(38, 31, 87)",
                        marginLeft: "150px",
                        textAlign: "center",

                    }}>
                        <div style={{ display: "flex", fontWeight: "bold", borderBottom: "1px solid black" }}>
                            <div style={{ width: "40%", height: "40px", }}>
                                <p style={{ padding: "10px" }}>Interpretation Reference :</p>
                            </div>
                        </div>
                        <div style={{ display: "flex", fontWeight: "bold", borderBottom: "1px solid black", height: "40px" }}>
                            <div style={{ width: "60%", borderRight: "1px solid rgb(38, 31, 87)", height: "40px", }}>
                                <p style={{ padding: "10px" }}>Copy Number Status</p>
                            </div>
                            <div style={{ width: "40%", height: "40px", }}>
                                <p style={{ padding: "10px" }}>Final Ratio [FR] </p>
                            </div>
                        </div>
                        <div style={{ display: "flex", borderBottom: "1px solid black" }}>
                            <div style={{ width: "60%", borderRight: "1px solid rgb(38, 31, 87)", height: "40px", }}><p style={{ padding: "10px" }}>Normal </p></div>
                            <div style={{ width: "40%", height: "40px", }}> <p style={{ padding: "10px" }}>0.80 &lt; FR &lt; 1.20</p></div>
                        </div>
                        <div style={{ display: "flex", borderBottom: "1px solid black" }}>
                            <div style={{ width: "60%", borderRight: "1px solid rgb(38, 31, 87)", height: "40px", }}> <p style={{ padding: "10px" }}> Homozygous deletion </p></div>
                            <div style={{ width: "40%", height: "40px", }}> <p style={{ padding: "10px" }}>FR = 0 - &lt; 0.10</p> </div>
                        </div>
                        <div style={{ display: "flex", borderBottom: "1px solid black" }}>
                            <div style={{ width: "60%", borderRight: "1px solid rgb(38, 31, 87)", height: "40px", }}> <p style={{ padding: "10px" }}>Hetrozygous deletion </p></div>
                            <div style={{ width: "40%", height: "40px", }}> <p style={{ padding: "10px" }}>0.40 &lt; FR &lt; 0.65</p></div>
                        </div>
                        <div style={{ display: "flex", borderBottom: "1px solid black" }}>
                            <div style={{ width: "60%", borderRight: "1px solid rgb(38, 31, 87)", height: "40px", }}> <p style={{ padding: "10px" }}>Hetrozygous duplication </p></div>
                            <div style={{ width: "40%", height: "40px", }}> <p style={{ padding: "10px" }}>1.30 &lt; FR &lt; 1.65</p></div>
                        </div>
                        <div style={{ display: "flex", borderBottom: "1px solid black" }}>
                            <div style={{ width: "60%", borderRight: "1px solid rgb(38, 31, 87)", height: "40px", }}> <p style={{ padding: "10px" }}>Hetrozygous triplication / Homozygous duplication </p></div>
                            <div style={{ width: "40%", height: "40px", }}> <p style={{ padding: "10px" }}>1.75 &lt; FR &lt; 2.15</p></div>
                        </div>

                    </div>
                    <br />
                    <div style={{ width: "96%", padding: 15, textAlign: "left", fontSize: "18px", marginLeft: "35px", wordBreak: "break-word" }}>
                        <p>
                            <b>NOTE :</b> Smaller deletions, duplications and point mutation in the SMN1 and SMN2 genes are not detected by this technique.The coding regions of the SMN1 and SMN2 genes were examined. Changes further into the introns or in other non-coding regions of the gene would not be detected.
                        </p>
                    </div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            METHODOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {smnMethodology.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", fontSize: "18px" }}
                                            rows={4}
                                            cols={114}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateMethology(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    {/* <div className="br">.</div> */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "20px" }}>DISCLAIMER</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        <br />
                        <ul>
                            <li>
                                <p>Spinal muscular atrophy (SMA) is an autosomal recessive neuromuscular disorder, with an incidence of
                                    approximately 1 in 10,000 births. The condition has variable severity and age of onset, and has been categorized into clinical types 0-IV. SMA I accounts for 60% of all SMA and has onset of symptoms in infancy.</p>
                            </li>
                            <li>
                                <p>
                                    MLPA assay for the molecular diagnosis of SMA is based on a kit containing several probes for the SMA critical
                                    region, including specific probes for SMN1 and SMN2 genes, probes able to hybridize both genes and other
                                    probes for sequences mapped either within the SMA critical region or on other autosomal regions.
                                </p>
                            </li>
                            <li>
                                <p>
                                    A point mutation or polymorphism in the sequence detected by a probe, which results in reduced probe
                                    binding efficiency, can also cause a reduction in relative peak area. Therefore, single exon deletions detected by MLPA should always be confirmed by other methods like multiplex PCR or sequencing.
                                </p>
                            </li>
                            <li>
                                <p>
                                    MLPA cannot detect any changes that lie outside the target sequence of the probes and will not detect most
                                    inversions or translocations. Even when MLPA did not detect any aberrations, the possibility remains that
                                    biological changes in that gene or chromosomal region do exist but remain undetected.
                                </p>
                            </li>
                        </ul>
                    </div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="br">.</div>
                    <div className="main-content2">.</div>
                    <div className="pmain-content5">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{smnMlpaReport[0]?.designation}&nbsp;{smnMlpaReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{smnMlpaReport[0]?.pk}
                    </div>
                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "20px" }}>REFERENCES</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div className="contain" style={{ border: "none", width: "95%", backgroundColor: "white", marginLeft: "20px", fontSize: "18px" }}>
                        <ol>
                            <li>
                                <p>SchoutenJPetal.(2002)Relative quantification of 40 nucleic acid sequences by multiplex ligation-dependent probe
                                    amplification Nucleic Acids Res 30, e57.</p>
                            </li>
                            <li>
                                <p>
                                    Redeker,E.J.,et al.(2008).Multiplex ligation-dependent probe amplification(MLPA) enhancesthe molecular diagnosis of aniridia and related disorders Mol Vis14, 836-840.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Alias L et al. (2014). Improving detection and genetic counseling in carriers of spinal muscular atrophy with two
                                    copies of the SMN1 gene. Clin Genet. 85:470-475.
                                </p>
                            </li>
                        </ol>

                    </div>
                    <div className="main-content7">.</div>
                    {/* <div className="pmain-content5">.</div> */}
                    {/* <div className="br">.</div> */}
                    <div style={{ width: "95%", marginLeft: "30px" }}>
                        <p style={{ color: "white", backgroundColor: "#e30b2c", textAlign: "center", marginTop: "20px", height: "50px", fontSize: "18px" }}>Important: As per the PRE-NATAL DIAGNOSTIC TECHNIQUES (REGULATIONS & PREVENTION OF MISUSE) AMENDMENT ACT 2002, sex determination shall not be done for all prenatal samples.</p>
                    </div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {smnMlpadoctorlist && smnMlpadoctorlist?.length > 0 && smnMlpadoctorlist?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>

                    <div className="main-content2">.</div>
                    <div className="pmain-content5">.</div>
                    <div style={{ width: "93%", marginLeft: "30px" }}>
                        <div style={{ height: "80px", textAlign: "center", backgroundColor: "#9c9a95", fontWeight: "bolder", fontSize: "40px" }}>
                            <p style={{ padding: "5px" }}> CONDITIONS OF REPORTING</p></div>
                        <br />
                        <div style={{ fontSize: "18px" }}>
                            <ol>
                                <li>
                                    <p>
                                        It is Presumed that specimen belongs to patient named or identified, such verification being carried out at the point of generation of said specimen.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        A test might not be performed due to following reason: <br />
                                        - Specimen Quantity not sufficient (Inadequate collection/spillage during transit) <br />
                                        - Specimen Quality not acceptable (Hemolysis/clotted/lipemic.) <br />
                                        - Incorrect sample type <br />
                                        - Test cancelled either on request of patient or doctor <br />

                                    </p>
                                    <p>in any of the above case a fresh specimen will be required for testing and reporting.</p>
                                </li>
                                <li>
                                    <p>
                                        The results of the tests may vary from lab to lab; time to time for the same patient.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Partial representation of report is not allowed.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        The reported tests are for the notification of the referring doctor, only to assist him/her in the diagnosis and management of the patient.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        This report is not valid for Medico Legal Purpose.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Applicable Jurisdiction will be of "Delhi" for any dispute/claim concerning the test(s) & results of the test (s).

                                    </p>
                                </li>
                            </ol>
                        </div>

                        {/* <div className="main-content2">.</div>
                        <div className="main-content3">.</div>
                        <div className="main-content4">.</div> */}



                    </div>

                    {/* footer section starting */}
                    <div className="page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${smnMlpaReport[0]?.uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>geneticcounselors@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                </div>
            </div >
        </Grammarly >
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,

})(JakReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}
